import React from 'react';
import './App.scss'
import { DatePicker } from './DatePicker';
import { DataTable } from './DataTable';
import { Graph, MonthlyAggregateGraph, CompareMonthlyAggregateGraph } from './Graph';
import { FileUpload } from './FileUpload';

function filterData(data: any, startDate: Date, endDate: Date) {
  const startISODate = startDate.toISOString().split('T')[0]
  const endISODate = endDate.toISOString().split('T')[0]
  return [data[0]].concat(data
    .slice(1)
    .filter((row: any) => row[0] >= startISODate && row[0] <= endISODate)
  )
}

function getGraphData(data: any) {
  return data.slice(1).map((row: any) => ([row[0], row[1]]))
}

class App extends React.Component {
  state = {
    dateRange: {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    },
    page: 'graph',
    calendarOpen: false,
    differenceChecked: false,
    selectedYear: '2021',
    data: [],
    minDate: "",
    maxDate: ""
  }

  constructor(props: any) {
    super(props)
    this.setDateRange = this.setDateRange.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  async componentDidMount() {
    const dataResponse = await fetch("/api/data")
    const dataJson = await dataResponse.json()
    const data = dataJson.map((row: any) => row.slice(0, 9))
    const maxDate = data[1][0]
    const minDate = data[data.length - 1][0]
    this.setState({
      dateRange: {
        startDate: new Date(minDate),
        endDate: new Date(maxDate),
        key: 'selection'
      },
      data,
      minDate,
      maxDate
    })
  }

  setDateRange(ranges: any) {
    this.setState({
      dateRange: {
        startDate: ranges.selection.startDate,
        endDate: ranges.selection.endDate,
        key: 'selection'
      }
    })
  }

  differenceIsChecked(checked: boolean) {
    this.setState({
      differenceChecked: checked
    })
  }

  handleChange(event: any){
    this.setState({ selectedYear: event.target.value });
  }

  render() {
    if (!this.state.data) {
      return null
    }
    const filteredData = filterData(this.state.data, this.state.dateRange.startDate, this.state.dateRange.endDate)
    const graphData = getGraphData(filteredData)
    return (
      <div className="app">
        <div className="navigation">
          <div className={"navigation__item" + (this.state.page === 'graph' ? " navigation__item--selected" : "")}
            onClick={() => this.setState({page: 'graph'})}>Graph</div>
          <div className={"navigation__item" + (this.state.page === 'table' ? " navigation__item--selected" : "")}
            onClick={() => this.setState({page: 'table'})}>Table</div>
          <div className={"navigation__item" + (this.state.page === 'upload' ? " navigation__item--selected" : "")}
            onClick={() => this.setState({page: 'upload'})}>Upload</div>            

          <div className="calendar"
            onClick={() => this.setState({calendarOpen: !this.state.calendarOpen})}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
          </div>
        </div>
        {this.state.calendarOpen &&
          <DatePicker 
            setDateRange={this.setDateRange} 
            dateRange={this.state.dateRange}
            minDate={new Date(this.state.minDate)}
            maxDate={new Date(this.state.maxDate)}
          />
        }
        {this.state.page === 'graph' && <>
            <Graph 
              data={graphData}
            />
            <MonthlyAggregateGraph 
              data={graphData}
            />
            <div className="checkbox-block">
              <label htmlFor="showDifferenceCheckbox" className="checkbox-label">Show monthly compare graph</label>
              <input id="showDifferenceCheckbox" type="checkbox" className="big-checkbox" checked={this.state.differenceChecked} onChange={() => this.differenceIsChecked(!this.state.differenceChecked)} />
              <select value={this.state.selectedYear} onChange={this.handleChange}>
                <option value="2021">2021</option>
                <option value="2022">2022</option>
              </select>
            </div>
            { this.state.differenceChecked &&
            <CompareMonthlyAggregateGraph 
              data={graphData}
              selectedYear={this.state.selectedYear} 
            />
          }
          </>
        }
        {this.state.page === 'table' && <DataTable 
            data={filteredData} 
          />
        }
        {this.state.page === 'upload' && <FileUpload />}
      </div>
    );
  }
}

export default App;
